import { makeStyles } from "tss-react/mui";

const useOptionsListStyles = makeStyles()((theme) => ({
  divider: {
    borderColor: theme.palette.strokes.defaultGrey,
  },
  grid: {
    minHeight: "100Vh",
  },
  bottomGrid: {
    height: "100%",
  },
  notAllowed: {
    pointerEvents: "none",
    textDecoration: "none",
  },
  link: {
    textDecoration: "none",
  },
  dbList: {
    padding: `${theme.spacing(1)} ${theme.spacing(2)}`,
  },
  logout: {
    backgroundColor: theme.palette.surface.highlighted,
    borderRadius: 4,
    color: theme.palette.text.accent,
    margin: `${theme.spacing(1)} ${theme.spacing(2)}`,
    padding: `${theme.spacing(2)}  ${theme.spacing(2)}`,
  },
  userName: {
    fontWeight: 500,
  },
  listItems: {
    fontSize: "1.125rem",
    gap: 0,

    "@media (min-height: 600px)": {
      gap: "4px",
    },
  },
}));

export default useOptionsListStyles;
